<template>
  <div class="" >
    <!-- Snackbar for notifications -->
    <v-snackbar
      v-model="snackbar.active"
      centered
      timeout="2000"
      :color="snackbar.color"
      :v-html="snackbar.text"
    >
    </v-snackbar>
    
    <v-card>
      <v-row class="">
        <v-col cols="12" class="pt-0 black pb-11">
          <v-container style="max-width:420px"  class="px-0 mt-0 pt-0">
            <div class="pt-3 text-caption grey--text white px-2" style="border-bottom: 1px solid #ddd!important;">iBookRestaurant.com</div>
            <v-card-title class="py-0 px-2 white">
              <div style="font-family: Montserrat, arial, sans-serif; font-weight:800; font-size:24px;color: #020e18" class="pb-1 ">
                {{settings.brand||'&nbsp;'}}
              </div>
              <v-spacer></v-spacer>
              <div>
                <v-btn icon @click="toggleHelp">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </div>
            </v-card-title>
            <v-row class=""> 
              <v-col cols="12">               
                <!-- BookingTab overlay (shown on top of tab system, not part of it) -->
                <div v-if="showBooking">
                  <BookingTab 
                    ref="bookingTab"
                    :customer-id="customerId"
                    :is-active="showBooking"
                    :initial-open-bookings="openBookings"
                    @change-tab="showBooking = false; mainTab = 'Info'"
                    @wipe-out="dialog_wipeOut = true"
                  />
                </div>

                <!-- Normal tab content (hidden when booking is open) -->
                <v-tabs-items v-else v-model="mainTab" touchless>        
                  <!-- Tab 0: Info -->
                  <v-tab-item value="Info" class="pt-0">
                    <InfoTab 
                      :customer-id="customerId"
                      :is-active="mainTab === 'Info'"
                      @change-tab="showBooking = true"
                      @open-bookings-loaded="openBookings = $event"
                      @manage-reservations="onManageReservations"
                    />
                  </v-tab-item>

                  <!-- Tab 1: Reviews -->
                  <v-tab-item value="Reviews" v-if="settings && settings.options && (settings.options.showTripAdvisorReviewsInDirectBooking==='1' || settings.options.showGoogleReviewsInDirectBooking==='1')">
                    <ReviewsTab 
                      :customer-id="customerId"
                      :is-active="mainTab === 'Reviews'"
                      @change-tab="mainTab = $event"
                    />
                  </v-tab-item>                    

                  <!-- Tab 2: Menu (conditional) -->
                  <v-tab-item value="Delivery" v-if="settings && settings.options && (settings.options.showDelivery === '1' ||settings.options.deliveryURL)">
                    <DeliveryTab 
                      :customer-id="customerId"
                      :is-active="mainTab === 'Delivery'"
                      @change-tab="mainTab = $event"
                    />
                  </v-tab-item>

                  <!-- Tab 2: Menu (conditional) -->
                  <v-tab-item value="Menu" v-if="settings && settings.options && (settings.options.showMenu === '1' || settings.options.menuURL)">
                    <MenuTab 
                      :customer-id="customerId"
                      :is-active="mainTab === 'Menu'"
                      @change-tab="mainTab = $event"
                    />
                  </v-tab-item>

                  <!-- Tab 3/2: FAQ -->
                  <v-tab-item value="FAQ">
                    <FaqTab 
                      :customer-id="customerId"
                      :is-active="mainTab === 'FAQ'"
                      @change-tab="mainTab = $event"
                    />
                  </v-tab-item>

                </v-tabs-items>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>

      <!-- Fixed bottom navigation with horizontal sliding -->
      <div class="bottom-nav-bar d-flex justify-center">
        <!-- Few items: stretch to fill full width -->
        <div v-if="tabItems.length <= 3" class="d-flex" style="height:48px">
          <v-btn
            v-for="item in tabItems"
            :key="item"
            text tile :ripple="false"
            class="flex-grow-1 px-0"
            style="height:48px"
            @click="switchTab(item)"
          >
            <div class="d-flex flex-column align-center">
              <span
                class="text-uppercase font-weight-black"
                style="font-size:0.9rem"
                :class="mainTab === item ? 'black--text' : 'grey--text'"
              >{{$t(page+'.'+item)}}</span>
              <div v-if="mainTab === item" style="height:2px;width:32px;background:black;margin-top:3px;border-radius:2px"></div>
            </div>
          </v-btn>
        </div>

        <!-- Many items: scrollable slide group -->
        <v-slide-group
          v-else
          v-model="mainTab"
          show-arrows
          center-active
          mandatory
          style="height:48px"
        >
          <v-slide-item
            v-for="item in tabItems"
            :key="item"
            :value="item"
            v-slot="{ active, toggle }"
          >
            <v-btn
              text tile :ripple="false"
              class="px-4"
              style="height:48px;min-width:80px"
              @click="toggle(); switchTab(item)"
            >
              <div class="d-flex flex-column align-center">
                <span
                  class="text-uppercase font-weight-black"
                  style="font-size:0.75rem"
                  :class="active ? 'black--text' : 'grey--text'"
                >{{$t(page+'.'+item)}}</span>
                <div v-if="active" style="height:2px;width:32px;background:black;margin-top:3px;border-radius:2px"></div>
              </div>
            </v-btn>
          </v-slide-item>
        </v-slide-group>
      </div>
    </v-card>

    <!-- ─── WIPE OUT CONFIRMATION DIALOG ──────────────────────────── -->
    <v-dialog v-model="dialog_wipeOut" max-width="360" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          <v-icon color="error" left>mdi-delete-forever</v-icon>
          Wipe Out
        </v-card-title>
        <v-card-text class="text-body-2 pt-2">
          This will permanently delete your cookies and settings. Are you sure?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_wipeOut = false">Cancel</v-btn>
          <v-btn color="error" text @click="confirmWipeOut()">Wipe Out</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ─── HELP DIALOG ──────────────────────────────────────────── -->
    <v-dialog v-model="dialog_help" max-width="480" scrollable>
      <v-card outlined>
        <v-card-title class="text-subtitle-1 font-weight-bold pb-1">
          <template v-if="helpStep === 1">
            <div style="font-size:24px;font-family: montserrat, arial, sans-serif; font-weight:800" class="pb-1">{{settings.brand||'&nbsp;'}}</div>
          </template>
          <template v-else>
            <span>
              {{helpTitles[helpStep]}}
            </span>            
          </template>
          <v-spacer></v-spacer>
          <v-btn v-if="helpStep==1" fab icon small @click="dialog_help = false"><v-icon>mdi-close</v-icon></v-btn>
          <v-btn v-else fab icon small @click="helpStep = 1"><v-icon>mdi-arrow-left</v-icon></v-btn>
        </v-card-title>
        <v-divider style="min-width:100%;margin:0!important"></v-divider>

        <v-card-text class="px-2 pb-2">

          <!-- Stepper: Info / Anonymize / Re-link -->
          <v-stepper v-model="helpStep" flat class="elevation-0">
            <v-stepper-items>

              <!-- STEP 1: Usage info -->
              <v-stepper-content step="1" class="pa-0">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-bold">{{ $t(page+'.Welcome, with this application you can') }}:</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon>mdi-calendar-check</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-bold">{{ $t(page+'.Make a reservation') }}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption text-wrap">{{ $t(page+'.Select date, covers and time slot, fill in your details and confirm') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon color="warning">mdi-pencil</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-bold">{{ $t(page+'.Modify / Cancel / Query') }}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption text-wrap">{{ $t(page+'.In Manage Reservation you can see, edit or cancel your reservations') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon color="error">mdi-link-variant</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-bold">{{ $t(page+'.Delete User') }}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption text-wrap">{{ $t(page+'.Want to wipe out Cookies and Settings? Click here!') }}</v-list-item-subtitle>
                      <v-list-item-action>
                        <v-btn small outlined color="error" @click="wipeOut()">
                      <v-icon left>mdi-delete-forever</v-icon>
                      Wipe Out
                    </v-btn>
                      </v-list-item-action>
                    </v-list-item-content>
                  </v-list-item> 
                  <v-list-item>
                    <v-list-item-icon><v-icon color="success">mdi-link-variant</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-bold">{{ $t(page+'.Recover User') }}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption text-wrap">{{ $t(page+'.Changed Phone? Deleted Browser History or Cookies? You can re-join via OTP') }}</v-list-item-subtitle>
                      <v-list-item-action>
                        <v-btn small outlined color="success" @click="helpStep = 3">
                          <v-icon left>mdi-link-variant</v-icon>
                          Get OTP
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item-content>
                  </v-list-item>                                    
                  <v-list-item>
                    <v-list-item-icon><v-icon color="warning">mdi-credit-card</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-bold">{{ $t(page+'.Prepayment') }}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption text-wrap">{{ $t(page+'.Some slots require a deposit via Stripe The card is charged or held depending on the restaurant policy') }}</v-list-item-subtitle>
                      <v-list-item-subtitle class="text-caption text-wrap">{{ $t(page+'.IMPORTANT:Cancellations and refunds are processed instantly, but your bank may take 3–10 business days to update your balance') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon color="green">mdi-whatsapp</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-bold">{{ $t(page+'.WhatsApp') }}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption text-wrap">{{ $t(page+'.You could receive a message related to your reservation') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon color="info">mdi-shield-account</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-bold">{{ $t(page+'.Your data') }}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption text-wrap">{{ $t(page+'.Your data is stored securely and used only for booking management') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon color="error">mdi-incognito</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-bold">{{ $t(page+'.Anonymization') }}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption text-wrap">{{ $t(page+'.Anonymize your Name, Surname and phone with just one click') }}</v-list-item-subtitle>
                      <v-list-item-action>
                        <v-btn small outlined color="error" @click="helpStep = 2">
                      <v-icon left>mdi-incognito</v-icon>
                      Anonymize Me
                    </v-btn>
                      </v-list-item-action>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon><v-icon color="success">mdi-silverware-variant</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2 font-weight-bold">{{ $t(page+'.Interested in the App?') }}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption text-wrap">{{ $t(page+'.Have a Restaurant, Pizzeria or interested investing?') }}</v-list-item-subtitle>
                      <v-list-item-action>
                        <v-btn small outlined color="success" href="https://wa.me/393505992731" target="_blank">
                      <v-icon left>mdi-whatsapp</v-icon>
                      Contact Us
                    </v-btn>
                      </v-list-item-action>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                
              </v-stepper-content>

              <!-- STEP 2: Anonymize -->
              <v-stepper-content step="2" class="pa-0">
                <v-alert type="warning" dense outlined class="text-body-2 mb-3">
                  This will permanently remove your personal data (name, phone, email) from our records. Your booking history will be anonymized and cannot be recovered.
                </v-alert>
                <v-text-field
                  v-model="helpConfirmText"
                  label="Type DELETE to confirm"
                  outlined dense
                  hide-details
                  class="mb-3"
                ></v-text-field>
                <v-btn
                  block color="error" dark small
                  :disabled="helpConfirmText !== 'DELETE'"
                  :loading="helpLoading"
                  @click="doAnonymize()"
                >
                  <v-icon small left>mdi-incognito</v-icon>
                  Anonymize My Data
                </v-btn>
              </v-stepper-content>

              <!-- STEP 3: Re-link account by phone + OTP verify -->
              <v-stepper-content step="3" class="pa-0">
                <!-- Phase 1: enter phone -->
                <template v-if="!helpOtpSent">
                  <p class="text-body-2 mb-3">If you changed device or cleared your data, enter your phone number to re-link your account.</p>
                    <v-select
                      :color="settings.options.color"
                      dense
                      outlined
                      v-model="helpCountryCode"
                      :items="countries"
                      :label="$t(page+'.Country Code')"
                      hide-details
                      item-value="value"
                      :item-text="item => item.namel+' +'+item.value"
                    >
                      <template v-slot:item="slotProps">
                        <i :class="['mr-2','em',slotProps.item.flag]"></i>
                        {{slotProps.item.namel}} + {{slotProps.item.value}}
                      </template>
                      <template v-slot:selection="data">
                        <i :class="['mr-2','em',data.item.flag]"></i>
                        +{{data.item.value}}
                      </template>
                    </v-select>                  
                  <v-text-field
                    v-model="helpPhone"
                    label="WhatsApp number"
                    outlined dense
                    append-icon="mdi-whatsapp"
                    placeholder=""
                    hide-details
                    reverse
                    class="my-3"
                    type="tel"
                    v-mask="'### ### ## ##'"
                  ></v-text-field>
                  <v-btn
                    block color="info" dark
                    :disabled="!helpPhone || helpPhone.replace(/\s/g,'').length < 9"
                    :loading="helpLoading"
                    @click="doRelink()"
                  >
                    <v-icon small left>mdi-whatsapp</v-icon>
                    Get OTP
                  </v-btn>
                </template>

                <!-- Phase 2: enter OTP -->
                <template v-else>
                  <v-alert type="success" dense outlined class="text-body-2 mb-3">
                    OTP sent to <strong>{{ helpPhone }}</strong>
                  </v-alert>
                  <v-text-field
                    v-model="helpOtp"
                    label="Enter OTP code (9 digits)"
                    outlined dense
                    append-icon="mdi-numeric"
                    type="text"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    placeholder="000-000-000"
                    v-mask="'###-###-###'"
                    class="mb-3"
                    reverse
                    :maxlength="11"
                    :minlength="11"
                    :loading="helpLoading"
                    :hint="helpOtpError"
                    :error="!!helpOtpError"
                    persistent-hint
                    @input="onOtpInput"
                  ></v-text-field>
                </template>
              </v-stepper-content>

              <!-- STEP 4: Success -->
              <v-stepper-content step="4" class="pa-0 text-center">
                <v-icon color="success" style="font-size:80px" class="mt-4">mdi-check-circle</v-icon>
                <p class="text-h6 success--text mt-3">{{ helpSuccessMsg }}</p>
                <v-btn small outlined class="mt-4" @click="dialog_help = false; helpStep = 1; showBooking = false; mainTab = 'Info'">
                  Close
                </v-btn>
              </v-stepper-content>

              <!-- STEP 5: Failed -->
              <v-stepper-content step="5" class="pa-0 text-center">
                <v-icon color="error" style="font-size:80px" class="mt-4">mdi-close-circle</v-icon>
                <p class="text-h6 error--text mt-3">{{ helpOtpError }}</p>
                <v-btn small outlined class="mt-4" @click="dialog_help = false; helpStep = 1; showBooking = false; mainTab = 'Info'">
                  Close
                </v-btn>
              </v-stepper-content>              

            </v-stepper-items>
          </v-stepper>

        </v-card-text>
      </v-card>
    </v-dialog>    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import InfoTab    from './tabs/InfoTab.vue'
import MenuTab    from './tabs/MenuTab.vue'
import FaqTab     from './tabs/FaqTab.vue'
import ReviewsTab from './tabs/ReviewsTab.vue'
import BookingTab from './tabs/BookingTab.vue'
import DeliveryTab from './tabs/DeliveryTab.vue'
export default {
  components: { InfoTab, BookingTab, MenuTab, FaqTab, ReviewsTab, DeliveryTab },
  data() {
    return {
      page: "Booking",
      mainTab: 'Info',
      showBooking: false,
      customerId: null,
      openBookings: null,
      booking: { "origin": null },
      snackbar: { active: false, color: 'success', text: '' },
      dialog_help: false,
      helpStep: 1,
      helpLoading: false,
      helpConfirmText: '',
      helpPhone: '',
      helpSuccessMsg: '',
      // Step 3: re-link OTP
      helpOtpSent: false,
      helpOtp: '',
      helpOtpError: '',
      helpOtpReady: false,

      helpCountryCode: 39,
      helpTitles: [null, null,'Anonymize','Get OTP','Success','Error'],

      dialog_wipeOut: false
    }
  },
  created() {
    this.isDarkMod = false;  
  },
  methods: {
    onManageReservations() {
      this.showBooking = true;
      this.mainTab = 'Info';
    },
    switchTab(item) {
      if (this.$refs.bookingTab) {
        this.$refs.bookingTab.resetLoadedBooking()
      }
      this.showBooking = false
      this.mainTab = item
    },
    toggleHelp() {
      this.helpStep = 1
      this.helpConfirmText = ''
      this.helpPhone = ''
      this.helpOtpSent = false
      this.helpOtp = ''
      this.helpOtpError = ''
      this.dialog_help = true
    },
    wipeOut() {
      this.dialog_wipeOut = true
    },
    confirmWipeOut() {
      this.dialog_wipeOut = false
      localStorage.removeItem('customerId')
      location.reload()
    },
    async doAnonymize() {
      this.helpLoading = true
      try {
        const csrf = sessionStorage.getItem('csrf')
        const customerId = localStorage.getItem('customerId')
        const res = await this.$http.post('/booking/booking_stepper.php', {
          action: 'optOut',
          csrf,
          payload: { customerId }
        })
        const newCsrf = res.headers['x-csrf-token']
        if (newCsrf) sessionStorage.setItem('csrf', newCsrf)
        if (res.data.errorid === '0') {
          localStorage.removeItem('customerId')
          sessionStorage.clear()
          this.helpSuccessMsg = 'Your data has been anonymized.'
          this.helpStep = 4
        } else {
          this.helpSuccessMsg = res.data.message || 'An error occurred.'
          this.helpStep = 4
        }
      } catch (e) {
        console.error('doAnonymize error', e)
        this.helpSuccessMsg = 'Connection error. Please try again.'
        this.helpStep = 4
      } finally {
        this.helpLoading = false
      }
    },

    // Step 3: send OTP to phone for re-link
    async doRelink() {
      this.helpLoading = true
      try {
        const res = await this.$http.post('/booking/booking_stepper.php', {
          action: 'sendOtp',
          payload: {
            countryCode: this.helpCountryCode,
            phone: this.helpPhone.replace(/\s/g, ''),
            //customerId: localStorage.getItem('customerId'),
            //locale: this.settings.locale
          }
        })
        const newCsrf = res.headers['x-csrf-token']
        if (newCsrf) sessionStorage.setItem('csrf', newCsrf)

        if (res.data.errorid === '0') {
          this.helpOtpReady = false
          this.helpOtpSent = true
          this.helpOtp = ''
          this.helpOtpError = ''
          // Clear after browser autofill, then allow onOtpInput to process user input
          setTimeout(() => { this.helpOtp = ''; this.helpOtpReady = true }, 300)
        } 
        else
        {
          this.helpOtpError = res.data.message || 'Failed to send OTP.'
          this.helpStep = 5
        }
      } catch (e) {
        console.error('doRelink error', e)
        this.helpOtpError = 'Connection error. Please try again.'
      } finally {
        this.helpLoading = false
      }
    },

    // Step 3: called on each keypress in OTP field — auto-verify at 9 digits
    async onOtpInput(val) {
      if (!this.helpOtpReady) return
      const digits = val ? String(val).replace(/-/g, '') : ''
      if (digits.length < 9) {
        this.helpOtpError = ''
        return
      }
      this.helpLoading = true
      this.helpOtpError = ''
      try {
        const otp = digits;
        const res = await this.$http.post('/booking/booking_stepper.php', {
          action: 'recoverAccount',
          payload: {
            phone: this.helpPhone.replace(/\s/g, ''),
            otp: otp,
            countryCode: this.helpCountryCode,
            //locale: this.settings.locale,
            customerId: localStorage.getItem('customerId')
          }
        })
        console.log(585,res)
        const newJwt = res.headers['authorization']
        if (newJwt) {
          this.$http.defaults.headers.common['Authorization'] = newJwt
          sessionStorage.setItem('jwt', newJwt)
        }
        const newCsrf = res.headers['x-csrf-token']
        if (newCsrf) sessionStorage.setItem('csrf', newCsrf)

        if (res.data.errorid === '0' && res.data.payloads && res.data.payloads.rc>0) 
        {
          const customerId = res.data.payloads.customerId
          if (customerId) localStorage.setItem('customerId', customerId)
          this.helpSuccessMsg = 'Account re-linked successfully!'
          this.helpStep = 4
        } 
        else
        {
          this.helpOtpError = res.data.message || 'Invalid OTP. Please try again.'
          this.helpStep = 5
        }
        // Reload page after short delay so tokens/storage are refreshed
        setTimeout(() => { window.location.reload() }, 2500)
      } catch (e) {
        console.error('onOtpInput error', e)
        this.helpOtpError = 'Connection error. Please try again.'
      } finally {
        this.helpLoading = false
      }
    },

 
  },
  computed: {
    ...mapGetters(['settings', 'countries']),
    tabItems() {
      const options= this.settings && this.settings.options
      const items = ['Info','Reviews']
      //if (options && (options.showTripAdvisorReviewsInDirectBooking==='1' || options.showGoogleReviewsInDirectBooking==='1')) items.push('Reviews')
      if (options && (options.showDelivery==='1' || options.deliveryURL )) items.push('Delivery')
      if (options && (options.showMenu==='1' || options.menuURL)) items.push('Menu')
      items.push('FAQ')
      //console.log('631 Computed tabItems', items)
      return items
    },
    isDarkMod: {
      get() { return this.dark; },
      set(value) {
        this.$vuetify.theme.dark = value;
        this.$store.dispatch("scheme/setDarkTheme", value);
      }
    },    
  }
}
</script>
<style scoped>
  .bottom-nav-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 48px;
    background: white;
    border-top: 1px solid #e0e0e0;
    z-index: 6;
  }
  .minWidth-30 { min-width: 20px!important; }
  .bottom-nav-bar {
  max-width: 420px;
  width: 100%;
  border-radius: 0px !important;
  
  /* Centers the fixed/absolute element on desktop */
  left: 50% !important;
  transform: translateX(-50%);
}
</style>